import request from 'superagent'
import querystring from 'querystring'
import { rootPath, errHandler } from './config'

const xhr = ({ url, body = null, method = 'get' }) => {
  // P.S: 此处引入了 ES6 的 Promise 实现
  return new Promise((resolve, reject) => {
      var mth = method.toUpperCase();
      var r = request(mth, rootPath + url).type('text/plain');

      // 跨域允许带上 cookie（http://visionmedia.github.io/superagent/#cors）
      // r.withCredentials()

      if (mth == 'POST') {
          if (!!body) {
              body = JSON.stringify(body);
          }
          r = r.send(body)
      }
      else if (mth == 'GET') {
          if (!!body) {
			//   body.language = 'CN'
              body = querystring.stringify(body);
          }
          r = r.query(body)
      }

      r.end((err, re) => {
        if (err)
          return reject({msg:'系统繁忙，请稍后再试'})

        if (!re.body && !re.text)
          return resolve(null)

		var result = re.body
		if (!result) {
			result = JSON.parse(re.text)
		}

        if (result.code) {
          errHandler(result.msg)
          return reject(result)
        }

        resolve(result.t || result)
      })
  })
}

export default xhr
